export type FinanceInventoryContextType = {
  componentLoaders: ComponentLoaderTypes,
  changeLoaderState: (loaderObject: ComponentLoaderTypes) => void,
  currentActivityList: IActivityItem[];
  onPageChange: (action: IPageChangeAction) => void;
  pageNumber: number;
  activityType: string;
  setActivityType: React.Dispatch<React.SetStateAction<string>>;
  setBranchIds: React.Dispatch<React.SetStateAction<string[]>>;
  branchIds: string[],
  resetPageData: () => void;
  allPagesVisited: boolean;
  selectedActivityRow: IActivityItem | undefined;
  activityDetail: IActivityDetail | undefined,
  setSelectedActivityRow: React.Dispatch<React.SetStateAction<IActivityItem | undefined>>;
  activityListsByPage: Record<string, IActivityItem[]>;
  saveInventoryActivity: (activityDetail: IActivityDetail) => void
  submitInventoryActivity: (callback: (isActionSucess: boolean) => void) => void
  uploadAttachment: (file: File) => void,
  downloadAttachment: (attachment: IAttachment) => void,
  deleteAttachment: (attachment: IAttachment) => void,
  editPostFinalData: (activityDetail: IActivityDetail) => void
  applyFilteredActivity?: (filters: Partial<IGetActivityList>) => void;
  activityFilterObj: Partial<IGetActivityList>;
  setActivityFilterObj: React.Dispatch<React.SetStateAction<Partial<IGetActivityList>>>;
  submitBulkApproval: (ids: string[], onComplete?: () => void) => void;
  rejectInventoryActivity: (callback: (isActionSucess: boolean) => void) => void

}

// export type ComponentLoaderTypes = Record<LOADERS_TYPES, boolean>

export type ComponentLoaderTypes = {
  [key in LOADERS_TYPES]: boolean;
};


export type IPageChangeAction = "next" | "prev";

export interface ILastKey {
  lastId: string;
  lastTimeStamp: string;
}

export interface IGetActivityList {
  activityType: string,
  branchIds: string[],
  pageSize: number,
  lastKey?: ILastKey,
  status: string,
  fromDate?: string | null;
  toDate?: string | null;
  postFinalFilter?: string;
  isPostFinalActivityEdited?: boolean;
  globalOrderSearch?: string;
  sourceBranchIds?: string[];
  supplierId?: string
}
export interface IActivityItem {
  activityType: string
  activityDate: string
  itemQty: number
  mid: string
  branchId: string
  orderNumber: string
  sourceOrderNumber: string
  sourceBranchId: string
  systemOrderId: string
  status: string
  netCost: number
  url: string
  lastModifiedByUser: string
  supplierName: string
  sourceBranchName: string
  sourceBranchCode: string
  postFinalDate: string
  totalTax: number
  isPostFinalActivityEdited: boolean
  supplierInvoiceNumber: string
  targetBranchName: string
  targetBranchCode: string
  postFinalStage: string
}

// ======== Activity Detail Type start ========
export interface IActivityDetail {
  mid: string
  branchId: string
  activityDate: string
  businessDay: string
  itemQty: number
  activityType: string
  orderNumber: string
  sourceIndentOrder: any
  parentOrderNumber: string
  postFinalDate: string
  currency: string
  status: string
  itemTotalCost: number
  itemTotalTax: number
  itemNetCost: number
  attachments: IAttachment[],
  totalCharge: number
  chargeTotalTax: number
  netCharge: number
  itemTotalCharge: number
  itemChargeTotalTax: number
  itemNetCharge: number
  totalCost: number
  totalTax: number
  netCost: number
  materialCost: number
  byProductCost: number
  taxList: ITaxList[]
  discountSummary: IDiscountSummary[]
  terms: string
  additionalMsg: string
  supplierInvoiceNumber: string
  initiatedBy: IInitiatedBy
  updatedBy: IUpdatedBy
  eventLog: IEventLog[]
  supplierId: string
  supplierInfo: ISenderReceiverInfo
  chargeSummary: any[]
  hideInventoryActDetails: boolean
  fssaiCode: string
  brandName: string
  items: IActivityIndividualItem[]
  itemActivities?: IActivityIndividualItem[]
  materials: any[]
  byProducts: any[]
  header: IHeader
  allowedActions: IAllowedActions
  info: ISenderReceiverInfo
  targetBranchInfo: ISenderReceiverInfo
  placeOfSupply: string
  supplierInvoiceDate: string
  sourceOrderNumber: string
  sourceOrderDate: string
  postFinalStage: string
}

export interface IDiscountSummary {
  discountType: DISCOUNT_TYPE_ENUMS
  discountCode: string
  discountRate: number
}

export interface ITaxList {
  name: string
  amount: number
  taxableAmount: number
  creditAmount: number
}

export interface IInitiatedBy {
  date: string
  businessDay: string
  deviceIdentifier: string
  deviceLabel: string
  buid: string
  userId: string
  userName: IUserName
}

export interface IUserName {
  firstName: string
}

export interface IUpdatedBy {
  date: string
  businessDay: string
  deviceIdentifier: string
  deviceLabel: string
  buid: string
  userId: string
  userName: IUserName
}

export interface IEventLog {
  status: string
  eventBy: IEventBy
}

export interface IEventBy {
  date: string
  businessDay: string
  deviceIdentifier: string
  deviceLabel: string
  buid: string
  userId: string
  userName: IUserName
}

export interface IActivityIndividualItem {
  itemId: string
  itemType: string
  itemQty: number
  itemName: string
  skuCode: string
  categoryId: string
  categoryName: string
  inventoryItemNature: string
  measuringUnit: string
  unitCost: number
  discountList: any[]
  indirectDiscountList: any[]
  cost: number
  itemTaxList: any[]
  totalTax: number
  netCost: number
  conversion: number
  perishable: boolean
  totalInputTaxCredit: number
  adhocTaxList: IAdhocTaxList[]
  taxExcludesAED: boolean
  addExciseDuty: number
  lessExciseDuty: number
  inventoryUnit: string
  currentStock: number
  taxIfFree: boolean
  skipTaxCalculation: boolean
  expiryList: IExpiryList[]
}

export interface IAdhocTaxList {
  name: string
  isCredit: boolean
  taxableAmount: number
  amount: number
  creditAmount: number
}

export interface IExpiryList {
  itemQty: number;
  conversion?: number;
  batchNumber?: string;
  expiryDate?: string;
  isVerified?: boolean;
  supplierItemName?: string;
  supplierMeasuringUnit?: string;
}

export interface IHeader {
  activityTitle: string
  branchAddress: IBranchAddress
  branchName: string
  branchCode: string
  businessName: string
  showItemBaseAmount: boolean
}

export interface IBranchAddress {
  addressLine: string
  city: string
  state: string
  country: string
  countryCode: string
  geolocation: number[]
}

export interface IAllowedActions {
  attachment: IAttachmentActions
}

export interface IAttachmentActions {
  create: boolean
  delete: boolean
  max: number
  maxFileSizeInKB: number
  mimeTypes: string[]
}

export interface ISenderReceiverInfo {
  businessName: string
  supplierCode: string
  address: IAddress
  phoneNumber: number
  supplierId: string
  branchName: string
}

export interface IAddress {
  addressLine: string
  city: string
  state: string
  country: string
  zip: string
  countryCode: string
  geolocation: number[]
}

// ======== Activity Detail Type end ========

export const enum BATCH_EDIT_ENUMS {
  QUANTITY = "qty",
  BATCH_NUMBER = "bno",
}

export const enum DISCOUNT_TYPE_ENUMS {
  ABSOLUTE = "Absolute",
  PERCENTAGE = "Percentage",
}

export const enum LOADERS_TYPES {
  GENERAL = "GENERAL",
  DOWNLOAD = "DOWNLOAD",
  DELETE = "DELETE",
  UPLOAD = "UPLOAD",
  MARK_APPROVED = "MARK_APPROVED",
  EDITING = "EDITING",
  REJECTED = "REJECTED"
}
export interface IAttachment {
  id: string
  fileName: string
  eventBy: IEventBy
}

export interface IEventBy {
  date: string
  businessDay: string
  deviceIdentifier: string
  deviceLabel: string
  buid: string
  userId: string
}

export type InventorySuppliersType = {
  additionalInfo: Record<string, string>;
  address: Record<string, any>;
  branchId: string;
  channelDefId: string;
  createTaxInvoice: boolean;
  createdBy: string;
  createdDate: string;
  isNegotiable: boolean;
  lastModifiedBy: string;
  lastModifiedDate: string;
  mid: string;
  status: string;
  supplierCode: string;
  supplierName: string;
  type: string;
  version: number;
}
